import FilterInput from './filterInput';
import FilterRangeInput from './filterRangeInput';
import './filters-group.scss';

const FiltersGroup = ({ group }) => {

    const renderCheckboxesGroup = () => {
        return <div className="filters-list">
            {group.data.map(filter => 
                <FilterInput 
                    key={'input-' + filter.id} 
                    data={{
                        id: filter.id,
                        type: group.input, 
                        name: filter.id,
                        active: filter.active,
                        label: filter.label,
                        disabled: filter.disabled
                    }} 
                />
            )}
        </div>;
    }
    
    const renderRangeSlider = () => {
        return <FilterRangeInput group={group} />;
    }

    if(!group.data.length){
        return false;
    }

    return(
        <div className="filters-group">
            <p className="filters-group-title">{group.label}</p>
                { group.input === 'range' ? renderRangeSlider() : null }
                { group.input === 'checkbox' ? renderCheckboxesGroup() : null }
        </div>
    )
};

export default FiltersGroup;